import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { UpploadService } from "../service";
import { safeListen, fitImageToContainer, canvasToBlob } from "../helpers/elements";
import { blobToUpploadFile } from "../helpers/files";

var Camera = /*#__PURE__*/function (_UpploadService) {
  _inherits(Camera, _UpploadService);

  var _super = _createSuper(Camera);

  function Camera() {
    var _this;

    _classCallCheck(this, Camera);

    _this = _super.apply(this, arguments);
    _this.name = "camera";
    _this.icon = "<svg aria-hidden=\"true\" viewBox=\"0 0 256 256\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M63 65l17-33c2-3 5-5 9-5h78c4 0 8 2 9 5l17 33h33c17 0 30 13 30 29v106c0 16-13 29-30 29H30c-17 0-30-13-30-29V94c0-16 13-29 30-29h33zm65 126c27 0 49-22 49-49 0-26-22-48-49-48s-49 22-49 48c0 27 22 49 49 49zm0-20c-16 0-30-13-30-29s14-28 30-28 30 12 30 28-14 29-30 29zm79-48c5 0 10-4 10-9 0-6-5-10-10-10-6 0-10 4-10 10 0 5 4 9 10 9z\" fill=\"#000\" fill-rule=\"nonzero\"/></svg>";
    _this.color = "#16a085";
    _this.canvas = document.createElement("canvas");
    _this.gotError = false;
    _this.waiting = false;
    _this.frontCamera = false;

    _this.supports = function () {
      return !!(window.navigator.mediaDevices && window.navigator.mediaDevices.enumerateDevices && !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };

    _this.template = function (_ref) {
      var translate = _ref.translate;
      return "\n      <div class=\"service-main\">\n        <div class=\"camera-waiting\">".concat(translate("services.camera.waiting"), "</div>\n        <div class=\"camera-error\">\n          <p>").concat(translate("services.camera.unableToRead"), "</p>\n          <p><a href=\"https://uppload.js.org/help/camera\" target=\"_blank\">").concat(translate("needHelp"), "</a></p>\n        </div>\n        <div class=\"camera-success\">\n          <video class=\"camera-stream\"></video>\n        </div>\n      </div>\n      <footer class=\"service-footer\">\n        <!--<button\n          class=\"camera-switch uppload-button\"\n        >").concat(translate("services.camera.switch"), "</button>-->\n        <button\n          class=\"camera-click uppload-button uppload-button--cta\"\n          style=\"background: ").concat(_this.color, "\"\n        >").concat(translate("services.camera.button"), "</button>\n      </footer>\n      <button class=\"need-help-link\"><span>").concat(translate("needHelp"), "</span aria-hidden=\"true\"><span>?</span></button>\n    ");
    };

    _this.stop = function () {
      if (_this.stream) _this.stream.getTracks().forEach(function (track) {
        return track.stop();
      });
    };

    _this.handlers = function (params) {
      _this.waiting = true;

      _this.update(params);

      var constraints = {
        audio: false,
        video: {
          width: 1280,
          height: 1280
        }
      };

      _this.startStream(params, constraints);

      var clickButton = params.uppload.container.querySelector(".camera-click");
      if (clickButton) safeListen(clickButton, "click", _this.clickPhoto.bind(_assertThisInitialized(_this), params));
      var switchButton = params.uppload.container.querySelector(".camera-click");
      if (switchButton) safeListen(switchButton, "click", _this.switchCamera.bind(_assertThisInitialized(_this), params));
      var helpButton = params.uppload.container.querySelector(".need-help-link");
      if (helpButton) safeListen(helpButton, "click", function () {
        return params.showHelp("/services/camera");
      });
    };

    return _this;
  }

  _createClass(Camera, [{
    key: "update",
    value: function update(params) {
      var waiting = params.uppload.container.querySelector(".camera-waiting");

      if (waiting) {
        waiting.style.display = "none";
        waiting.style.opacity = "0";
      }

      var error = params.uppload.container.querySelector(".camera-error");

      if (error) {
        error.style.display = "none";
        error.style.opacity = "0";
      }

      var success = params.uppload.container.querySelector(".camera-success");

      if (success) {
        success.style.display = "none";
        success.style.opacity = "0";
      }

      var footer = params.uppload.container.querySelector(".service-footer");

      if (footer) {
        footer.style.display = "none";
        footer.style.opacity = "0";
      }

      if (this.gotError) {
        if (error) {
          error.style.display = "";
          error.style.opacity = "1";
        }
      } else if (this.waiting) {
        if (waiting) {
          waiting.style.display = "";
          waiting.style.opacity = "1";
        }
      } else {
        if (success) {
          success.style.display = "";
          success.style.opacity = "1";
        }

        if (footer) {
          footer.style.display = "";
          footer.style.opacity = "1";
        }
      }
    }
  }, {
    key: "switchCamera",
    value: function switchCamera(params) {
      this.frontCamera = !this.frontCamera;
      var constraints = {
        audio: false,
        video: {
          width: 1280,
          height: 1280,
          facingMode: this.frontCamera ? "user" : "environment"
        }
      };
      this.startStream(params, constraints);
    }
  }, {
    key: "clickPhoto",
    value: function clickPhoto(params) {
      this.canvas = document.createElement("canvas");
      var video = params.uppload.container.querySelector("video.camera-stream");
      if (!video) return;
      if (!this.stream) return;
      var videoSize = video.getBoundingClientRect();
      var width = videoSize.width;
      var height = videoSize.height;
      this.stream.getTracks().forEach(function (track) {
        var settings = track.getSettings();
        if (settings.width) width = settings.width;
        if (settings.height) height = settings.height;
      });
      this.canvas.width = width;
      this.canvas.height = height;
      var context = this.canvas.getContext("2d");
      if (!context) return;
      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      context.drawImage(video, 0, 0, width, height);
      canvasToBlob(this.canvas).then(function (blob) {
        return params.next(blobToUpploadFile(blob, "camera-photo-".concat(Math.random().toString(36).slice(2), ".png"), "image/png", new Date()));
      });
    }
  }, {
    key: "startStream",
    value: function startStream(params, constraints) {
      var _this2 = this;

      this.stop();
      window.navigator.mediaDevices.getUserMedia(constraints).then(function (mediaStream) {
        _this2.stream = mediaStream;
        var video = params.uppload.container.querySelector("video.camera-stream");

        if (video) {
          video.srcObject = mediaStream;
          safeListen(video, "loadedmetadata", function () {
            return video.play();
          });
          fitImageToContainer(params, video);
        }
      }).catch(function () {
        _this2.gotError = true;
      }).then(function () {
        _this2.waiting = false;

        _this2.update(params);
      });
    }
  }]);

  return Camera;
}(UpploadService);

export { Camera as default };